import angular from 'angular';
import '../../app.constants';
import '../../services/reception';

const module = angular.module('whyline.controllers.reception-information-screen', [
  'whyline.constants',
  'whyline.services.reception',
]);

const ReceptionInformationScreenController = (ReceptionService, $scope, $timeout, $state, SAFE_STATES) => {
  /*@ngInject*/

  ReceptionService.SetButtonStatus('back', true);
  ReceptionService.SetButtonStatus('forward', false);
  ReceptionService.SetButtonStatus('status-text', true);
  ReceptionService.SetButtonStatus('browserBack', true);

  $scope.informationScreen = ReceptionService.GetInformationScreen();

  let returnToHome = $timeout(() => {
    $state.go(SAFE_STATES.receptionWelcome);
  }, 10000);

  $scope.$on('$destroy', () => {
    $timeout.cancel(returnToHome);
  });
};

module.exports = module.controller('ReceptionInformationScreenController', ReceptionInformationScreenController);
